import { MouseEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { AuthActions, Mui, MuiIcons } from "@leap4/frontend";
import { logoutUrl } from "../../config/generals";

const { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Box, Divider, Avatar } = Mui;
const { Logout } = MuiIcons;

const initialOf = (email: string): string => (email.trim()[0] || "?").toUpperCase();

export const ProfileMenu = ({ email }: { email: string }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const signOut = async () => {
        setAnchorEl(null);
        await AuthActions.logout(dispatch, history, logoutUrl);
    };

    return (
        <>
            <IconButton
                onClick={(e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)}
                aria-label="Account"
                aria-haspopup="true"
                aria-expanded={open || undefined}
                aria-controls={open ? "profile-menu" : undefined}
                sx={{ ml: 0.5 }}
            >
                <Avatar sx={{ width: 28, height: 28, fontSize: "0.75rem", bgcolor: "primary.main" }}>{initialOf(email)}</Avatar>
            </IconButton>
            <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                slotProps={{ paper: { sx: { minWidth: 220, mt: 1 } } }}
            >
                <Box sx={{ px: 2, py: 1.5, display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Avatar sx={{ width: 40, height: 40, bgcolor: "primary.main" }}>{initialOf(email)}</Avatar>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="subtitle2" noWrap title={email}>
                            {email}
                        </Typography>
                    </Box>
                </Box>
                <Divider />
                <MenuItem onClick={signOut}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Log out</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
};
